// extracted by mini-css-extract-plugin
export default {"serviceSection":"Service_serviceSection__HoNGR","container":"Service_container__bl5ud","card":"Service_card__oeDy6"};